/**
 * Random heading variants for authenticated task creation form.
 * Shown when user is logged in and viewing the task creation page.
 */
export const AUTHENTICATED_HEADINGS = [
	"What task to do?",
	"What work to get done?",
	"What work to do?",
	"What work should I do?",
	"What should I do next?",
	"What do you want done?",
	"What can I do for you?",
	"What can I take care of?",
	"What can I get done for you?",
	"What can I help with?",
	"Any tasks to get done?",
	"Any tasks to run today?",
	"Anything to get done?",
	"Anything you want finished?",
	"Anything you want handled?",
	"Anything you want me to do?",
	"Anything I should take care of?",
	"Something you want done?",
	"Got something to delegate?",
	"Got a task for me?",
	"What should I run?",
	"What should I handle?",
	"What should I finish?",
	"What do you want done?",
	"What do you want finished?",
	"What do you want handled?",
	"What do you want to know?",
] as const;
